import styled from 'styled-components/macro';
import { ButtonLink } from '@yme/molecules/buttons';
import { colorBrandYamahaRed, colorCoreBlack900Base, colorCoreGray100 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { escapeImageUrl } from '@yme/utils/common';
export const TeaserContainerStyled = styled(FlexWrapper) `
  ${({ imagePath }) => imagePath
    ? `background: url('${escapeImageUrl(imagePath)}') center center / cover no-repeat`
    : ''};
  ${({ linkUrl }) => linkUrl && 'cursor: pointer'};
  color: ${({ imagePath }) => escapeImageUrl(imagePath) ? colorCoreGray100 : colorCoreBlack900Base};
  background-size: cover;
  min-height: 500px;
  padding: 20px;
  max-width: 75rem;
  margin-left: auto;
  margin-right: auto;
`;
export const ButtonTeaserLinkStyled = styled(ButtonLink) `
  & span {
    border-color: ${colorBrandYamahaRed};
    background-color: ${colorBrandYamahaRed};
    border-radius: 0;
  }
`;
export const StyledFlexWrapper = styled(FlexWrapper) `
  max-width: 500px;
  flex-direction: column;
  align-self: flex-start;
  margin-top: auto;
  gap: 20px;
`;
